module.exports = __webpack_public_path__ + "img/partner_2.48797b1.png";